var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{class:_vm.type,attrs:{"shadow":_vm.shadow,"body-style":_vm.bodyStyle,"header":_vm.header}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }